import { Button, Col, Spinner } from 'react-bootstrap';

const GenerateInvoiceButton = ({
  onClick,
  disabled,
  isLoading
}: {
  onClick: () => void;
  disabled: boolean;
  isLoading: boolean;
}) => {
  return (
    <Col className="d-flex justify-content-center align-items-center">
      <Button
        className="w-85 mt-4"
        style={{ minWidth: '150px' }}
        variant="primary"
        onClick={onClick}
        disabled={disabled}
      >
        {isLoading ? (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
        ) : (
          'Generate Invoice'
        )}
      </Button>
    </Col>
  );
};

export default GenerateInvoiceButton;
